export enum IgnoreEventElement {
  INPUT = 'INPUT',
  TEXTAREA = 'TEXTAREA',
  SELECT = 'SELECT',
}

export enum IgnoreEventRole {
  switch = 'switch',
  slider = 'slider',
  radio = 'radio',
  range = 'range',
  tab = 'tab',
}

export const PAGE_CONTAINER_CLASSNAME = 'page-container';
export const EDITOR_NAVBAR_ID = 'editor-navbar-menu';
export const EDITOR_TOOLBAR_ID = 'editor-toolbar-menu';
export const EDITOR_ACTIVE_PAGE_FOCUS_ID = 'editor-active-page-focus-id';
export const EDITOR_REPLACE_MENU_TABLIST_ID = 'editor-replace-menu-tablist-id';
export const WIDGET_MENU_ID = 'widget-menu-container-id';

// TODO: The current export needs to be optimized for the design with many pages
// Limit it to 50 based on the metric and until we optimize the export
export const MAXIMUM_PAGE_LIMIT = 100;
